<div class="card shadow-sm rounded-3">
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="fw-bold text-dark m-0 d-flex align-items-center">
        <i class="la la-file-contract me-2"></i> {{ 'APARTMENT.CONTRACTS' | translate }}
      </h4>
      <button (click)="addContract()" class="btn btn-primary btn-sm py-2">
        <i class="las la-plus me-1"></i> {{ 'CONTRACTS.NEW_CONTRACT' | translate }}
      </button>
    </div>
    <p class="text-muted mb-4 mt-1">{{ 'CONTRACTS.CONTRACT_SUBTITLE' | translate }}</p>
    <div class="mt-4">
      <p-table
        [hasList]="service.hasList"
        (onLazyLoad)="loadData($event)"
        (onPage)="pageChange($event)"
        [columns]="fields"
        [dataKey]="'id'"
        [first]="first"
        [globalSearch]="globalSearch"
        [hasActions]="service.hasActions"
        [hasAdd]="service.hasAdd"
        [hasDelete]="service.hasDelete"
        [hasEdit]="service.hasEdit"
        [hasView]="service.hasView"
        [loading]="loading()"
        [rows]="rows"
        [scrollHeight]="'calc(111vh - 420px)'"
        [selectionMode]="'single'"
        [title]="service.title"
        [totalRecords]="total"
        [value]="list"
        paginatorPosition="bottom"
        tableStyleClass="table table-hover">

        <ng-template #cells let-data>
          @for (col of fields; track col) {
            <td>
              <span class="p-datatable-column-title">
                @if (col.iconClass) {
                  <i [class]="col.iconClass"></i>
                }
                {{ (col.label ?? col.fieldName) | translate }}
              </span>

              @switch (col.fieldName) {
                @case ('contractNumber') {
                  <a [routerLink]="data.rentType === RentType.BUILDING ? 
                     [Resources.PropertiesProfile | resourceById:data.buildingId] : 
                     [Resources.UniversalBillingApartmentsProfile | resourceById:data.apartmentId]"
                     storeBackRoute>
                     @if (data.rentType === RentType.BUILDING) {
                       {{ data.buildingCode || '-' }}
                     } @else {
                       {{ data.apartmentCode ||'-'}}
                     }
                  </a>
                }
                @case ('rentType') {
                  @switch (data.rentType) {
                    @case (RentType.BUILDING) {
                      <span class=""> <i class="bi bi-building me-1"></i> {{ ('RENT_TYPES.' + RentType[data.rentType] | translate ) }} </span>
                    }
                    @case (RentType.APARTMENT) {
                      <span class=""> <i class="me-1 la la-home"></i> {{ ('RENT_TYPES.' + RentType[data.rentType] | translate ) }} </span>
                    }
                    @default {
                      -
                    }
                  }
                }
                @case ('endDate') {
                  {{ data?.permanent ? ('CONTRACT.PERMANENT' | translate) : (data?.endDate ? (data?.endDate | date: 'y-MM-dd') : '-') }}
                }
                @case ('actions') {
                  <div class="d-flex align-items-center gap-2">
                    <a
                      [routerLink]="[Resources.PropertyContractsDetails | resourceById:data.id]"
                      storeBackRoute
                      ngbTooltip="{{ 'INVOICES.DETAILS' | translate }}"
                      class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center action-button">
                      <i class="las la-info-circle fs-20"></i>
                    </a>

                    <a
                      (click)="delete(data.id)"
                      ngbTooltip="{{ 'DELETE' | translate }}"
                      class="btn btn-sm btn-outline-danger d-flex align-items-center justify-content-center action-button">
                      <i class="las la-trash fs-20"></i>
                    </a>
                  </div>
                }
                @default {
                  <p-table-cell-value [data]="data" [column]="col"></p-table-cell-value>
                }
              }
            </td>
          }
        </ng-template>
        <!--    <a [routerLink]="[Resources.PropertyContractsDetails]">-->
        <!--      <i class="las la-file-alt me-1 fs-4"></i>-->
        <!--    </a>-->
      </p-table>
    </div>
  </div>
</div>
